module.exports = __webpack_public_path__ + "img/logo-light.4a795782.svg";